<template>
    <div class="returnPostage">
        <section class="section2">
            <br/>
            <div label="卡号：">
                <input label="卡号：" v-model="userInfo.mobile" type="text" placeholder="请输入你要查询的卡号">
            </div>
            <div class="button-group"> <!-- 新增类名 -->
                <mt-button type="primary" @click="selectOrderInfo()">查询信息</mt-button>
                <mt-button type="primary" @click="toActive()">复机</mt-button>
                <mt-button type="primary" @click="toReload()">刷新网络</mt-button>
            </div>

        </section>
        <section class="section1" v-if="showFlg">
            <ul>
                <li>
                    <label>ICCID：</label>
                    <span>{{ orderInfo.iccid }}</span>
                </li>
                <li>
                    <label>实名状态：</label>
                    <span>{{ orderInfo.authName }}</span>
                </li>
                <li>
                    <label>卡状态：</label>
                    <span>{{ orderInfo.stateName }}</span>
                </li>
                <li>
                    <label>冻结状态：</label>
                    <span>{{ orderInfo.dongName }}</span>
                </li>
                <li>
                    <label>群组状态：</label>
                    <span>{{ orderInfo.groupName }}</span>
                </li>

                <li>
                    <label>在用套餐：</label>
                    <span>{{ orderInfo.usePkgName }}</span>
                </li>

                <li>
                    <label>次月套餐：</label>
                    <span>{{ orderInfo.nextPkgName }}</span>
                </li>

                <li>
                    <label>充值优惠卷：</label>
                    <span>{{ orderInfo.priceName }}</span>
                </li>

                <li>
                    <label>用户余额：</label>
                    <span>{{ orderInfo.userAmount }}</span>
                </li>
                <li>
                    <label>绑定手机号：</label>
                    <span>{{ orderInfo.userPhone }}</span>
                </li>

                <li>
                    <label>套餐组：</label>
                    <span>{{ orderInfo.groupName }}</span>
                </li>
                <li>
                    <label>供应商：</label>
                    <span>{{ orderInfo.supplierName }}</span>
                </li>

            </ul>
        </section>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog } from "vant";
export default {
    data() {
        return {
            userInfo: {
                mobile: ''
            },
            showFlg: false,
            orderInfo: {

            }
        }
    },
    created() {
        if (this.$route.query.mobile) {
            this.userInfo.mobile = this.$route.query.mobile;
           // this.$dialog.alert({ title: '提示', message: '查询卡号'+ this.userInfo.mobile  });
            this.selectOrderInfo();
        }
    },
    methods: {
        selectOrderInfo() {
            if (this.userInfo.mobile == '') {
                this.$dialog.alert({ title: '提示', message: '请先输入手机号' });
                return;
            }
            wxRequest("userProblem/simInfo", this.userInfo, "post").then(res => {
                if (res.data.code == 200) {
                    this.orderInfo = res.data.data;
                    this.showFlg = true;
                } else {
                    this.showFlg = false;
                    this.$dialog.alert({ title: '提示', message: res.data.message });
                }
            })
        },
        toReload() {
            let data = {
                iccid: this.orderInfo.iccid,
            };
            wxRequest("sim/to/reload", data, "get").then((res) => {
                Dialog.alert({ title: "提示", message: res.data.message });
            });
        },
        toActive() {
            let data = {
                iccid: this.orderInfo.iccid,
            };
            Dialog.confirm({
                title: "提示",
                message:
                    "请您确保当前卡已完成实名认证并且拥有套餐 方可复机。复机完成后 打开飞行模式一下即可！",
            })
                .then(() => {
                    wxRequest("sim/to/active", data, "get").then((res) => {
                        Dialog.alert({ title: "提示", message: res.data.message });
                    });
                })
                .catch(() => { });
        },
    },

    mounted() {

    },
}
</script>

<style>
.returnPostage .van-field__body {
    height: 100%;
}

.returnPostage .van-button--small {
    height: 35px;
    width: 96%;
    letter-spacing: 1px;
}
</style>



<style lang="less" scoped>
.returnPostage {
    .button-group {
        display: flex;
        gap: 10px;
        justify-content: center;
        margin: 10px 0 30px;

        mt-button {
            flex: 1;
            max-width: 120px;
        }
    }

    .formLine {
        display: flex;
        margin-top: 10px;
        justify-content: center;
    }

    ::v-deep .section1 {
        margin: 0 10px 10px;
        padding: 10px;
        background: #fff;
        border-radius: 10px;

        ul li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #eaeaea;
            display: flex;
            justify-content: space-between;

            &:last-child {
                border-bottom: none;
            }

            span {
                color: #FF9C3C;
            }
        }
    }

    .section2 {
        div {
            margin: 10px 0 30px;
            padding: 0 10px;

            input[type=text] {
                border: 1px solid #e0e0e0;
                outline: none;
                padding: 8px;
                line-height: 1.6em;
                width: 100%;
                box-sizing: border-box;
            }
        }

    }
}
</style>